import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import * as _ from 'lodash';

import { environment } from 'src/environments/environment';
import { UtilService } from 'src/app/modules/shared/services/util.service';
import { TcbService } from 'src/app/modules/admin/services/tcb.service';

@Component({
  selector: 'app-tcb-coupons',
  templateUrl: './tcb-coupons.component.html',
  styleUrls: ['./tcb-coupons.component.scss']
})
export class TcbCouponsComponent implements OnInit {

  public loginData: any;

  public coupons: any = [];
  public couponsPage: number = 1;
  public couponsCount: number = 0;
  public couponsLoading: boolean = false;
  public displayType: string; // grid/list

  public metadataStatus: number; // 0/1

  constructor(
    private _router: Router,
    private _utilService: UtilService,
    private _tcbService: TcbService
  ) { }

  ngOnInit(): void {
    this.getStorageData();
  }

  async getStorageData() {
    this.loginData = await this._utilService.getStorageData('A_LOGIN');

    this.metadataStatus = 0; // Default without metadata
    this.displayType = 'grid'; // Default display type
    this.couponsPage = 1;

    this.getCoupons();
  }

  // On coupon status change
  onMetadataStatusChange(status: number){
    this.metadataStatus = status;

    this.couponsPage = 1;
    this.getCoupons();
  }

  // Change display type
  changeDisplayType(type: string) {
    this.displayType = type;
  }

  // Get coupons
  getCoupons() {
    this.coupons = [];
    this.couponsCount = 0;
    this.couponsLoading = true;

    this._tcbService.getTcbCoupons(this.loginData.token, this.loginData.user_details.user_id, this.metadataStatus, this.couponsPage).subscribe(async getTcbCouponsResponse => {
      this.couponsLoading = false;

      if (getTcbCouponsResponse.status === true) { // Success
        this.coupons = getTcbCouponsResponse.coupons;
        this.couponsCount = getTcbCouponsResponse.total_count;
      } else {
        this._utilService.showToast(getTcbCouponsResponse.message, '', 'error', {});
      }
    }, error => { // Error from getCoupons
      this.couponsLoading = false;
      this._utilService.showToast(environment.apiErrorMessage, '', 'error', {});
    });
  }

  // Coupons page change
  onCouponsPageChange(event: any) {
    this.couponsPage = event;
    this.getCoupons();
  }

  // On add metadata
  onAddMetadata (event: any) {
    if(event.action == 'metadata-added') {
      this.getCoupons();
    }
  }

}
